import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import product from '@/components/product'
import dynamic from '@/components/dynamic'
import aboutus from '@/components/aboutus'
import map from '@/components/map'
import recruit from '@/components/recruit'
import honor from '@/components/honor'
import newsdetail from '@/components/newsdetail'
import toudi from '@/components/toudi'
import founder from '@/components/founder'
import download from '@/components/download'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/product',
    name: 'product',
    component: product,
    meta: {
      title: '产品详情页'
    }
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    component: dynamic,
    meta: {
      title: '新闻动态详情页'
    }
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: aboutus,
    meta: {
      title: '关于我们公司介绍'
    }
  },
  {
    path: '/map',
    name: 'map',
    component: map,
    meta: {
      title: '公司地址'
    }
  },
  {
    path: '/recruit',
    name: 'recruit',
    component: recruit,
    meta: {
      title: '招聘信息页'
    }
  },
  {
    path: '/founder',
    name: 'founder',
    component: founder,
    meta: {
      title: '创始人介绍'
    }
  },
  {
    path: '/honor',
    name: 'honor',
    component: honor,
    meta: {
      title: '资质荣誉详情页'
    }
  },
  {
    path: '/newsdetail',
    name: 'newsdetail',
    component: newsdetail,
    meta: {
      title: '新闻详情页'
    }
  },
  {
    path: '/toudi',
    name: 'toudi',
    component: toudi,
    meta: {
      title: '投递简历页'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: download,
    meta: {
      title: '下载'
    }
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js